import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

declare const TPP_SNAP: any;

@Component({
    selector: 'blog-fs-blog-layout',
    templateUrl: './fs-blog-layout.component.html',
    styleUrls: ['./fs-blog-layout.component.scss'],
    imports: [CommonModule],
})
export class FsBlogLayoutComponent {
    @Input() public previewId?: string;
    @Input() public label?: string;

    public env = environment;

    public addSectionClicked(): void {
        //@TODO: move to service
        TPP_SNAP.setPreviewElement(this.previewId);
        TPP_SNAP.showEditDialog(this.previewId);
    }
}
